import Business from './business-page';
import RegisterBusinessForm from './register-business-form';
import DaNangBusiness from './danang-business';

export {
  Business,
  RegisterBusinessForm,
  DaNangBusiness
};



// WEBPACK FOOTER //
// ./components/business/index.js